const resolveErrorMessage = (axiosError) => {
  if (axiosError?.response?.status === 403) {
    return "You do not have permission to access this resource or perform this action."
  }

  const backendMessage =
    axiosError?.response?.data?.message || axiosError?.response?.data?.msg
  if (backendMessage) return backendMessage

  if (!axiosError?.response) {
    return "Unable to reach the server. Please check your connection and try again."
  }

  return "Something went wrong. Please try again."
}

const ApiError = ({ axiosError }) => {
  const message = resolveErrorMessage(axiosError)

  return (
    <div className="mt-2 p-4 bg-red-100 rounded-lg">
      <p className="text-center text-sm text-rose-700">{message}</p>
    </div>
  )
}

export default ApiError
